<template>
    <div id="catalog-category">
        <div class="d-flex justify-content-between align-items-center">
            <div
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                :content="$t('message.showCatalogCategories')"
                class="custom-checkbox2"
            >
                <a-switch v-model="catalogVisible" size="small">
                    <a-icon slot="checkedChildren" type="check" />
                    <a-icon slot="unCheckedChildren" type="close" />
                </a-switch>
                <span>{{ $t("message.openCatalog") }}</span>
            </div>
            <div class="d-flex gap-5" v-if="checkPermission(PERMISSION_TYPES['catalog.update'].tr.name)">
                <supsis-button primary style="margin-right: 8px" @click="showModal">
                    <md-icon style="color: white">add</md-icon>
                    {{ $t("message.changeTitle") }}
                </supsis-button>
                <supsis-button primary @click="isTitleModalShow">
                    <md-icon style="color: white">add</md-icon>
                    {{ $t("message.changeVisitorTitle") }}
                </supsis-button>
            </div>
        </div>

        <b-container v-if="catalogVisible" fluid>
            <div class="col-md-12">
                <div class="titleAlign">
                    <md-button class="arrow-class" v-if="!!navigation.length" @click="back">
                        <md-icon>arrow_back</md-icon>
                    </md-button>
                    <div v-if="!!navigation.length > 0" class="title">
                        {{ $_.last(navigation).languageContent[$i18n.locale].name }}
                    </div>
                    <div v-else class="title">{{ catalogTitle }}</div>
                </div>

                <!-- Tüm menü ve içeriklerin listelendiği yer-->
                <div class="menus">
                    <div v-for="cat in catalogs" v-if="catalogs.length" class="menu">
                        <CatalogMenu :data="cat" :navigate-to="navigateTo" />
                    </div>
                </div>
                <!-- Menülerin listelendiği yerin bitişi-->

                <!-- İçeriklerin listelendiği yer-->
                <CatalogContent
                    v-if="navigation.length && navigation[navigation.length - 1].type === 'content'"
                    :data="navigation[navigation.length - 1]"
                    @finish-update="() => back()"
                />

                <div
                    v-if="
                        (navigation.length && navigation[navigation.length - 1].type === 'menu') ||
                        (!navigation.length && checkPermission(PERMISSION_TYPES['catalog.create'].tr.name))
                    "
                    class="newButtons"
                >
                    <!-- Yeni menü ekleme yeri (tablarla tr en alıyoruz)-->
                    <div
                        v-if="!isCreateMenu"
                        :style="isCreateContent ? 'display: none;' : ''"
                        class="newMenu"
                        @click="onCreateCatalog()"
                    >
                        {{ $t("message.addNewMenu") }}
                    </div>
                    <b-tabs v-else-if="isCreateMenu">
                        <MultiContent v-model="inCatalogTitle" ref="MultiContent" />
                        <a-button class="actionsButtonCancel" @click="cancelMenu">
                            {{ $t("message.cancel") }}
                        </a-button>
                        <a-button class="actionsButton" @click="saveMenu">
                            {{ $t("message.save") }}
                        </a-button>
                    </b-tabs>

                    <!-- Yeni içerik ekleme yeri (tablarla tr en alıyoruz)-->
                    <div
                        v-if="!isCreateContent"
                        :style="isCreateMenu ? 'display: none;' : ''"
                        class="newMenu"
                        @click="onCreateCatalog('content')"
                    >
                        {{ $t("message.content") }}
                    </div>
                    <b-tabs v-else-if="isCreateContent">
                        <MultiContent v-model="inCatalogForm" ref="MultiContent" />
                        <a-button class="actionsButton" @click="cancelContent">
                            {{ $t("message.cancel") }}
                        </a-button>
                        <a-button class="actionsButton" @click="saveContent">
                            {{ $t("message.save") }}
                        </a-button>
                    </b-tabs>
                </div>
            </div>
        </b-container>
        <div v-else>
            <a-result :title="$t('message.catalogNotOpen')">
                <template #extra>
                    <a-button type="primary" @click="catalogVisible = true">
                        {{ $t("message.openTheCatalog") }}
                    </a-button>
                </template>
            </a-result>
        </div>
        <Modal2
            v-if="isModalShow"
            id="catalog-form"
            :title="$t('message.changeTitle')"
            :show-footer="false"
            size="lg"
            role="dialog"
            @cancel="hideModal"
            aria-labelledby="myModalLabel"
        >
            <b-row>
                <b-col md="12">
                    <b-row>
                        <b-col md="12">
                            <MultiContent v-model="catalogGeneralTitle" ref="MultiContent" />
                        </b-col>
                        <b-col md="12">
                            <div class="catalog-action-buttons">
                                <b-button @click="titleModalCancelClickHandler" style="margin-right: 6px">
                                    <template>
                                        {{ $t("message.cancel") }}
                                    </template>
                                </b-button>
                                <b-button variant="primary" @click="handleTitleSave">
                                    {{ $t("message.update") }}
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </Modal2>
        <Modal2
            v-if="isTitleModal"
            id="catalog-form"
            :title="$t('message.visitorScreenNaming')"
            :show-footer="false"
            size="lg"
            role="dialog"
            @cancel="isTitleModalHide"
            aria-labelledby="myModalLabel"
        >
            <div>
                <a-form-item :validate-status="errors.first('companyName') ? 'error' : 'success'" has-feedback.>
                    <a-input
                        :placeholder="$t('message.enterCatalogTitle')"
                        v-model="catalogMenuTitle"
                        v-validate="'required'"
                        name="companyName"
                    />
                </a-form-item>
            </div>
        </Modal2>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue";
import { log2 } from "../../../../../utils/log2";

import AppBreadCrumb from "../../../../../components/common/AppBreadCrumb.vue";
import CatalogMenu from "../../../../../components/CatalogMenu.vue";
import CatalogContent from "../../../../../components/CatalogContent.vue";
import { sendSocketMessage } from "../../../../../utils/socketStream";
import MultiContent from "../../../../../components/MultiContent.vue";
import { toArray2, toObject2 } from "../../../../../utils/languageContent";
import Modal2 from "../../../../../components/common/Modal2.vue";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

const initialObject = {
    languageContent: {},
    parentId: null,
    type: null,
};
const log = log2("Catalog");
const titleInitialObj = {
    languageContent: {
        en: {
            title: "",
        },
        tr: {
            title: "",
        },
        ru: {
            title: "",
        },
        es: {
            title: "",
        },
        ar: {
            title: "",
        },
        fr: {
            title: "",
        },
        de: {
            title: "",
        },
        it: {
            title: "",
        },
    },
};
const addNewMenuTitleObj = {
    languageContent: {},
};
export default {
    name: "Catalog",
    components: {
        SupsisButton,
        MultiContent,
        CatalogContent,
        CatalogMenu,
        AppBreadCrumb,
        CKEditor,
        Modal2,
    },
    data() {
        return {
            editor: ClassicEditor,
            catalogForm: _.cloneDeep(addNewMenuTitleObj),
            navigation: [],
            isCreateMenu: false,
            isCreateContent: false,
            oldTitle: "",
            handleSave: _.debounce((newSettings) => {
                const isValid = Date.now() - (this.mountedTime || Date.now()) > 2000; // defaulttan gerçeğe geçerken bir kere sunucuya gitmesini engellemek için alternatif başka çözüm var sa yapalım
                log("handleSave runned", {
                    newSettings,
                    initialized: this.settingInitialized,
                    isValid,
                    mountedTime: this.mountedTime,
                    diff: Date.now() - (this.mountedTime || Date.now()),
                });
                if (isValid) {
                    this.submitClicked = true;
                    const self = this;
                    this.$validator.validateAll().then((response) => {
                        if (response) {
                            self.updateSettings(newSettings)
                                .then(() => {
                                    sendSocketMessage("admin settings-updated", {
                                        siteId: self.site._id,
                                    });
                                    self.$toasted.show(self.$t("message.settingsSaved"), {
                                        duration: 3000,
                                        position: "bottom-center",
                                    });
                                })
                                .finally(() => {
                                    self.submitClicked = false;
                                });
                        } else {
                            self.$toasted.error(self.$t("message.settingFormWrong"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        }
                    });
                }
            }, 1000).bind(this),
            catalogTitleInit: _.cloneDeep(titleInitialObj),
            editorConfig: () => ({
                // The configuration of the editor.
                removePlugins: ["MediaEmbed", "AutoMediaEmbed"],
            }),
            newFormCatalogTitle: "",
            newCatalogTitle: "",
            isModalShow: false,
            isTitleModal: false,
        };
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapState({
            isAdmin: (state) => state.auth.adminUser != null,
            languages: (state) => state.language.languages,
            currLanguage: (state) => state.language.language,
            isDarkMod: (state) => state.app.darkMode,
            catalogs: (state) => state.catalog.catalogs,
            settings: (state) => state.setting.settings,
            settingInitialized: (state) => state.setting.initialized,
            site: (state) => state.site.site,
            defaultLang: (state) => state.setting.settings.language.clientDefault,
            systemLanguages: (state) => state.setting.settings.systemLanguages,
        }),
        catalogGeneralTitle: {
            get() {
                if (!this.systemLanguages) {
                    return [];
                }
                return [
                    {
                        type: "input",
                        field: "title",
                        label: this.$t("message.message"),
                        placeholder: this.$t("message.message"),
                        data: this.systemLanguages.reduce((acc, lang) => {
                            acc[lang] = _.get(this.catalogTitleInit.languageContent, `[${lang}].title`, "");
                            return acc;
                        }, {}),
                        validation: "required",
                    },
                ];
            },
            set(v) {
                this.catalogTitleInit.languageContent = this.systemLanguages.reduce((acc, lang) => {
                    acc[lang] = {};
                    for (const _v of v) acc[lang] = _v.data[lang];
                    return acc;
                }, {});
            },
        },
        inCatalogTitle: {
            get() {
                if (!this.systemLanguages) {
                    return [];
                }
                return [
                    {
                        type: "input",
                        field: "name",
                        label: this.$t("message.message"),
                        placeholder: this.$t("message.message"),
                        data: this.systemLanguages.reduce((acc, lang) => {
                            acc[lang] = _.get(this.catalogForm.languageContent, `[${lang}].name`, "");
                            return acc;
                        }, {}),
                        validation: "required",
                    },
                ];
            },
            set(v) {
                this.catalogForm.languageContent = this.systemLanguages.reduce((acc, lang) => {
                    acc[lang] = {};
                    for (const _v of v) acc[lang][_v.field] = _v.data[lang];
                    return acc;
                }, {});
            },
        },
        inCatalogForm: {
            get() {
                if (!this.systemLanguages) {
                    return [];
                }
                return [
                    {
                        type: "input",
                        field: "name",
                        label: this.$t("message.message"),
                        placeholder: this.$t("message.message"),
                        data: this.systemLanguages.reduce((acc, lang) => {
                            acc[lang] = _.get(this.catalogForm.languageContent, `[${lang}].name`, "");
                            return acc;
                        }, {}),
                        validation: "required",
                    },
                    {
                        type: "rich",
                        field: "content",
                        label: this.$t("message.message"),
                        placeholder: this.$t("message.message"),
                        data: this.systemLanguages.reduce((acc, lang) => {
                            acc[lang] = _.get(this.catalogForm.languageContent, `[${lang}].content`, "");
                            return acc;
                        }, {}),
                        validation: "required",
                    },
                ];
            },
            set(v) {
                this.catalogForm.languageContent = this.systemLanguages.reduce((acc, lang) => {
                    acc[lang] = {};
                    for (const _v of v) acc[lang][_v.field] = _v.data[lang];
                    return acc;
                }, {});
            },
        },
        catalogVisible: {
            get() {
                return this.settings.catalogVisible;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "catalogVisible",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        catalogTitle: {
            get() {
                let maybeCatalog = this.settings.catalogTitle.find((x) => x.languageCode === this.currLanguage.code);
                if (maybeCatalog) {
                    return maybeCatalog.content;
                }
                return "Catalog Menu";
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "catalogTitle",
                    value: value,
                });
                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        catalogMenuTitle: {
            get() {
                return this.settings.catalogMenuTitle;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "catalogMenuTitle",
                    value: value,
                });
                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        catalogTitleInitialObject: {
            get() {
                return this.settings.catalogTitle?.reduce((acc, cur) => {
                    acc[cur.languageCode] = cur.content;
                    return acc;
                }, {});
            },
            set(value) {
                this.catalogTitle.languageContent = toObject2(value, "title");
                this.addNewCatologTitle();
            },
        },
        catalogFormInitialObjectTitle: {
            get() {
                return toArray2(this.catalogForm, "languageContent", "name").languageContent;
            },
            set(value) {
                this.catalogForm.languageContent = toObject2(value, "name");
                this.addNewFormCatalogTitle();
            },
        },
        catalogFormInitialObjectInput: {
            get() {
                return toArray2(this.catalogForm, "languageContent", "content").languageContent;
            },
            set(value) {
                this.catalogForm.languageContent = toObject2(value, "content");
                this.addNewFormCatalogTitle();
            },
        },
    },
    methods: {
        ...mapActions({
            createCatalog: "catalog/createCatalog",
            getCatalogs: "catalog/getCatalogs",
            setSettingValue: "setting/setSettingValue",
            updateSettings: "setting/updateSettings",
        }),
        showModal() {
            this.isModalShow = true;
            this.setCatalogInitialObj();
        },
        hideModal() {
            this.isModalShow = false;
        },
        isTitleModalShow() {
            this.isTitleModal = true;
        },
        isTitleModalHide() {
            this.isTitleModal = false;
        },
        onCreateCatalog(type = "menu") {
            if (type === "menu") {
                this.isCreateMenu = true;
                setTimeout(() => {
                    document.getElementById("menuFocus").focus();
                }, 100);
            } else {
                this.isCreateContent = true;
                setTimeout(() => {
                    document.getElementById("contentFocus").focus();
                }, 100);
            }
            this.catalogForm = _.cloneDeep(initialObject);
            this.catalogForm.type = type;
            this.catalogForm.parentId = this.navigation.length ? _.last(this.navigation)._id : null;
            this.catalogForm.languageContent = this.languages.reduce((acc, cur) => {
                acc[cur.code] = {
                    name: null,
                    content: null,
                };
                return acc;
            }, {});
        },
        titleModalCancelClickHandler() {
            this.settings.catalogTitle = this.oldTitle;
            /*this.$bvModal.hide("catalog-form");*/
            this.hideModal();
        },
        formTitleChangeHandler(value) {
            this.newFormCatalogTitle = value;
            this.addNewFormCatalogTitle();
        },
        addNewFormCatalogTitle() {
            Object.keys(this.newFormCatalogTitle).forEach((key) => {
                if (!this.catalogForm.languageContent[key]) {
                    return (this.catalogForm.languageContent[key] = {
                        name: this.newFormCatalogTitle[key],
                        content: null,
                    });
                }
                this.catalogForm.languageContent[key].name = this.newFormCatalogTitle[key];
            });
        },
        catalogTitleChangeHandler(value) {
            this.newCatalogTitle = value;
            this.addNewCatologTitle();
        },
        addNewCatologTitle() {
            Object.keys(this.newCatalogTitle).forEach((key) => {
                this.catalogTitleInit.languageContent[key] = this.newCatalogTitle[key];
            });
        },
        handleKeyDown({ code }) {
            if (code === "Enter") {
                this.createCatalog(this.catalogForm).then(() => {
                    this.isCreateMenu = false;
                    this.catalogForm = null;
                });
            }
        },
        saveContent() {
            this.createCatalog(this.catalogForm).then(() => {
                this.isCreateContent = false;
                this.catalogForm = null;
            });
        },
        saveMenu() {
            log("saveMenu", this.$refs.multiContent);
            /*if (!!this.$refs.multiContent) {
                let from = Object.keys(this.$refs.multiContent.content)[0];
                let fromInput = Object.keys(this.$refs.multiContent.inputContent)[0];
                this.$refs.multiContent.translate(from);
                this.$refs.multiContent.translate(fromInput, true);
            }*/
            this.createCatalog(this.catalogForm).then(() => {
                this.isCreateMenu = false;
                this.catalogForm = null;
            });
        },
        cancelContent() {
            this.isCreateContent = false;
        },
        cancelMenu() {
            this.isCreateMenu = false;
        },
        navigateTo(cat) {
            log("navigateTo", cat);
            this.navigation.push(cat);
            this.getCatalogs(cat ? cat._id : null);
        },
        back() {
            log("back", {
                catalogs: this.catalogs,
                navigation: this.navigation,
            });
            this.navigation.pop();
            const last = _.last(this.navigation);
            this.getCatalogs(last ? last._id : null);
        },
        setCatalogInitialObj() {
            this.oldTitle = this.settings.catalogTitle;
        },
        handleTitleSave() {
            let savedTitle = [];
            for (let lang in this.catalogTitleInit.languageContent) {
                let langObjInit = {
                    content: this.catalogTitleInit.languageContent[lang] || "",
                    languageCode: lang,
                };
                savedTitle.push(langObjInit);
            }
            this.catalogTitle = savedTitle;
            /*this.$bvModal.hide("catalog-form");*/
            this.hideModal();
        },
    },

    mounted() {
        this.getCatalogs();
        this.mountedTime = Date.now();
    },
};
</script>

<style lang="scss" scoped>
#catalog-category {
    .newMenu {
        border: 1px dashed gray;
        cursor: pointer;
        padding: 10px;
        user-select: none;
        border-radius: 6px;
        width: 100%;
        margin-bottom: 10px;

        &:hover {
            background-color: #cce;
            text-decoration: underline;
        }
    }

    .menu {
        cursor: pointer;
        padding: 10px;
        user-select: none;
        border-radius: 6px;
        width: 100%;
        background-color: #fff;
        box-shadow: 0 0 3px #000000;
        margin-bottom: 10px;

        &:hover {
            background-color: #cce;
        }
    }

    .titleAlign {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 10px;
        margin: 8px 0;

        .title {
            font-size: 18px;
            font-weight: 500;
            margin-right: 100px;
        }

        .arrow-class {
            position: absolute;
            left: -35px;
        }
    }

    .actionsButton {
        padding: 6px 10px;
        margin: 8px 0;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
    }

    .actionsButtonCancel {
        padding: 6px 10px;
        margin: 8px 0;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
    }

    .custom-checkbox2 {
        background-color: #f3f6f9;
        border-radius: 6px;
        padding: 3px 6px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-family: Poppins;
        font-weight: 400;
        font-size: 12px;
        color: #1e1e2d;
        margin-right: 6px;
    }
}
</style>
<style lang="scss">
.catalog-action-buttons {
    display: flex;
    margin-top: 12px;
    justify-content: flex-end;
    align-items: flex-end;
}

#catalog-form {
    .ant-modal {
        width: max-content !important;
    }
}
</style>
